import { c as _c } from "react/compiler-runtime";
import { useQuery, useMutation, type UseQueryResult, type UseMutationResult } from '@tanstack/react-query';
import { signIn, getCurrentLoggedUser, signUp, gcpMarketplaceSignUp, gcpMarketplaceLogin, type AuthUserResp, type AuthSignUpReq, type AuthSignInReq, type MeUserResp, type GCPMarketplaceSignUpResponse, type GCPMarketplaceLoginResponse } from 'shared/api/auth';
import type * as fetch from 'shared/api/fetch';
const queryKeys = {
  loggedInUser: 'loggedInUser'
};
export const useSignIn = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: signIn
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useSignUp = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: signUp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useGCPMarketplaceSignUp = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: gcpMarketplaceSignUp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useGCPMarketplaceLogin = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: gcpMarketplaceLogin
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
const thirtyMinute = 30 * 60 * 1000;
export const UseQueryLoggedInUser = (accessToken: string): UseQueryResult<MeUserResp, fetch.ClientError> => {
  const enable = accessToken !== '';
  return useQuery({
    queryKey: [queryKeys.loggedInUser, accessToken],
    queryFn: async () => await getCurrentLoggedUser(),
    enabled: enable,
    retry: false,
    staleTime: thirtyMinute
  });
};